import MainLayout from "src/layouts/MainLayout/MainLayout";
import {
  EmailListSection,
  StatusToggle,
  EmailDetailSection,
  SearchSection,
} from "./components";
import { useConditionsInboxState } from "src/hooks/useConditionsInboxState";
import {
  SplitLayoutContainer,
  EmailDetailContainer,
  SearchContainer,
  DividerLine,
} from "./ConditionsInbox.styles";

export default function ConditionsInbox() {
  const {
    selectedEmailId,
    selectedEmail,
    selectedEmailAttachments,
    showCompleted,
    emails: filteredEmails,
    markEmailAsJunk,
    sendFiles,
    loadEmailDetails,
    updateAttachmentName,
    fetchAttachmentSignedUrl,
    renamedAttachments,
    setState,
  } = useConditionsInboxState();

  const handleEmailSelect = (emailId: string) => {
    setState((prev) => ({ ...prev, selectedEmailId: emailId }));
    loadEmailDetails(emailId);
  };

  const handleToggleShowCompleted = (showCompleted: boolean) => {
    setState((prev) => ({
      ...prev,
      showCompleted,
    }));
  };

  const handleBack = () => {
    setState((prev) => ({ ...prev, selectedEmailId: null }));
  };

  const handleMarkAsJunk = (emailId: string) => {
    markEmailAsJunk(emailId);
  };

  return (
    <MainLayout
      page="conditions-inbox"
      showHeading={true}
      totalCount={filteredEmails.length}
    >
      {!selectedEmail ? (
        <>
          <StatusToggle
            showCompleted={showCompleted}
            onChange={handleToggleShowCompleted}
          />
          <EmailListSection
            onEmailSelect={handleEmailSelect}
            emails={filteredEmails}
            selectedEmailId={selectedEmailId}
          />
        </>
      ) : (
        <SplitLayoutContainer>
          <EmailDetailContainer>
            <EmailDetailSection
              email={selectedEmail}
              attachments={selectedEmailAttachments}
              onBack={handleBack}
              onMarkAsJunk={handleMarkAsJunk}
              updateAttachmentName={updateAttachmentName}
              fetchAttachmentSignedUrl={fetchAttachmentSignedUrl}
              renamedAttachments={renamedAttachments}
            />
          </EmailDetailContainer>

          <DividerLine />

          <SearchContainer>
            <SearchSection
              selectedEmailId={selectedEmailId}
              attachments={selectedEmailAttachments}
              renamedAttachments={renamedAttachments}
              sendFiles={sendFiles}
            />
          </SearchContainer>
        </SplitLayoutContainer>
      )}
    </MainLayout>
  );
}
